var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"px-0":"","pb-0":""}},[_c('v-layout',{attrs:{"justify-space-around":""}},[_c('v-flex',{attrs:{"xs11":"","sm9":"","md6":"","text-xs-center":"","text-md-left":""}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"icon",attrs:{"src":"img/RGB_formal_Sauer_Lab.jpeg"}})])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md6":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2624d5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logo.vue
// module id = 158
// module chunks = 0